<template>
	<div class="quantity-config">
		<input
			class="quantity-config-input"
			:class="{ 'quantity-config-input-small' : small }"
			minlength="1"
			:readonly="readonly"
			:style="`color: ${theme.secondary}; outline-color: ${theme.primary};`"
			type="number"
			:value="quantity"
			@keyup.stop="$emit('change-value', $event)"
		/>
		<div class="quantity-config-buttons">
			<button
				class="quantity-config-btn"
				:class="{ 'quantity-config-btn-small' : small }"
				@click="$emit('add-quantity')"
			>
				+
			</button>
			<button
				class="quantity-config-btn"
				:class="{ 'quantity-config-btn-small' : small }"
				:disabled="!small ? quantity < 1 || isNaN(quantity) : quantity === 1 || isNaN(quantity)"
				@click="$emit('sub-quantity')"
			>
				-
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'quantity-config',
		props: {
			quantity: [Number, String],
			readonly: {
				default: true,
				type: Boolean,
			},
			small: {
				default: false,
				type: Boolean,
			},
			theme: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.quantity-config {
		display: inline-flex;

		&-input {
			background-color: color(newbackground);
			border-radius: 2px;
			font-size: size(large25);
			font-weight: weight(bold);
			height: 52px;
			margin-right: 9px;
			text-align: center;
			width: 88px;

			&-small {
				font-size: size(medium16);
				height: 48px;
				width: 53px;
			}

			&:not(.quantity-config-input-small) {
				width: 70px;

				@media (min-width: 936px) {
					width: 88px;
				}
			}
		}

		&-buttons {
			display: inline-block;
		}

		&-btn {
			background-color: color(newwarning);
			border-radius: 2px;
			color: color(white);
			display: block;
			font-size: size(large);
			font-weight: weight(bold);
			height: 24px;
			line-height: normal;
			width: 43px;

			&:first-child {
				margin-bottom: 4px;
			}

			&-small {
				font-size: size(medium);
				height: 22px;
				width: 26px;
			}

			&:not(.quantity-config-btn-small) {
				width: 34px;

				@media (min-width: 936px) {
					width: 43px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/shared/quantity-config.vue